import { FormSegmentedButton } from '@ipfabric/ui-components/FormSegmentedButton/FormSegmentedButton';
import { FormSwitch } from '@ipfabric/ui-components/FormSwitch/FormSwitch';
import { FormTextArea } from '@ipfabric/ui-components/FormTextArea/FormTextArea';
import { FormTextField } from '@ipfabric/ui-components/FormTextField/FormTextField';
import { SegmentButton } from '@ipfabric/ui-components/SegmentedButton/SegmentButton/SegmentButton';
import type { SiteSeparationAttributeTransformation } from '@ipfabric/utils/schema/siteSeparation/siteSeparationAttributeTransformation';
import { RegexSiteNameField } from './RegexSiteNameField';
import {
  CLOUD_RESOURCE_ID_TRANSFORMATION_TOOLTIP_TEXT,
  REGEX_TOOLTIP_TEXT,
  type RuleEditorContentProps,
  type RuleEditorValues,
  TRANSFORMATION_OPTIONS,
} from './RuleEditor.types';

export const CloudResourceIdRuleEditorContent = ({
  control,
}: RuleEditorContentProps) => (
  <>
    <FormSegmentedButton.Single<
      RuleEditorValues,
      SiteSeparationAttributeTransformation
    >
      control={control}
      label='Text transformation'
      labelTooltip={CLOUD_RESOURCE_ID_TRANSFORMATION_TOOLTIP_TEXT}
      name='transformation'
    >
      {TRANSFORMATION_OPTIONS.map(({ label, value }) => (
        <SegmentButton key={value} value={value} className='flex-1'>
          {label}
        </SegmentButton>
      ))}
    </FormSegmentedButton.Single>
    <FormTextField
      control={control}
      dataTestId='site-separation-regex'
      label='Regular expression'
      labelTooltip={REGEX_TOOLTIP_TEXT}
      name='regex'
      type='text'
    />
    <RegexSiteNameField
      control={control}
      dataTestId='site-separation-sitename'
      label='Site name'
    />
    <FormSwitch
      control={control}
      label='Include cloud devices discovered via SSH or Vendor API'
      name='applyToCloudInstances'
    />
    <FormTextArea
      control={control}
      dataTestId='site-separation-note'
      label='Rule description (optional)'
      name='note'
    />
  </>
);
